import { PrismaLabBanner } from "./prisma-lab-banner";

const PRISMA_LAB_URL = "https://prismalab.pi.gov.br/";

export const PrismaLabBannerContainer = () => {
  return <PrismaLabBanner url={PRISMA_LAB_URL} />;
};
